<template>
  <div class="searchFiltersValues">
    <div v-if="list.length" class="searchFiltersValues__filter searchFiltersValues__filter--purple">
      <div class="searchFiltersValues__filterInner">
        WYCZYŚĆ
        <button class="searchFiltersValues__filterRemove" @click="clearFilters">
          <span class="icon-line-close-bold" />
        </button>
      </div>
    </div>
    <template v-for="(item, index) in list">
      <div
        v-if="item.type === 'FormRange'"
        :key="`${index}`"
        class="searchFiltersValues__filterWrapper"
      >
        <div
          v-if="item.value.from && item.value.from > Math.floor(item.min)"
          class="searchFiltersValues__filter"
        >
          <div class="searchFiltersValues__filterInner">
            {{ item.name }} od: {{ item.value.from }}
            <button class="searchFiltersValues__filterRemove" @click="remove(item, 'from')">
              <span class="icon-line-close-bold" />
            </button>
          </div>
        </div>
        <div
          v-if="item.value.to && item.value.to < Math.ceil(item.max)"
          :key="`${index}__to`"
          class="searchFiltersValues__filter"
        >
          <div class="searchFiltersValues__filterInner">
            {{ item.name }} do: {{ item.value.to }}
            <button class="searchFiltersValues__filterRemove" @click="remove(item, 'to')">
              <span class="icon-line-close-bold" />
            </button>
          </div>
        </div>
      </div>
      <div
        v-else-if="item.type === 'FormCheckbox'"
        :key="index"
        class="searchFiltersValues__filterWrapper"
      >
        <div v-if="item.value" class="searchFiltersValues__filter">
          <div class="searchFiltersValues__filterInner">
            {{ item.name }}
            <button class="searchFiltersValues__filterRemove" @click="remove(item)">
              <span class="icon-line-close-bold" />
            </button>
          </div>
        </div>
      </div>
      <div
        v-else-if="item.filterType === 'FormCheckboxList'"
        :key="index"
        class="searchFiltersValues__filter"
      >
        <div class="searchFiltersValues__filterInner">
          {{ item.label }}
          <button class="searchFiltersValues__filterRemove" @click="remove(item)">
            <span class="icon-line-close-bold" />
          </button>
        </div>
      </div>
      <div v-else-if="item.type === 'FormRadio'" :key="index" class="searchFiltersValues__filter">
        <div class="searchFiltersValues__filterInner">
          {{ item.name }}:
          {{ getRadioValue(item) }}
          <button class="searchFiltersValues__filterRemove" @click="remove(item)">
            <span class="icon-line-close-bold" />
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SearchFiltersValues',
  props: {
    testProps: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      activeFilters: state => state.productsFilters.search.activeFilters,
      filters: state => state.productsFilters.search.filters,
    }),
    list() {
      const returnFilters = [];
      for (const key of Object.keys(this.activeFilters)) {
        const currentFilter = this.filters.filter(x => x.key === key)[0];
        if (!currentFilter) continue;
        if (currentFilter.type === 'FormCheckboxList') {
          this.filters
            .filter(x => x.key === key)[0]
            .values.filter(y => this.activeFilters[key].includes(y.value))
            .forEach(val => {
              val = Object.assign({}, val);
              returnFilters.push(
                Object.assign(Object.assign({}, val), {
                  filterName: currentFilter.name,
                  filterKey: currentFilter.key,
                  filterType: currentFilter.type,
                }),
              );
            });
        } else if (currentFilter.type === 'FormCheckbox') {
          if (this.activeFilters[key]) {
            returnFilters.push(
              Object.assign(Object.assign({}, currentFilter), { value: this.activeFilters[key] }),
            );
          }
        } else if (currentFilter.type === 'FormRange') {
          const rangeValue = Object.assign(Object.assign({}, currentFilter), {
            value: this.activeFilters[key],
          });
          if (
            Math.floor(rangeValue.value.from) > rangeValue.min ||
            Math.ceil(rangeValue.value.to) < rangeValue.max
          ) {
            returnFilters.push(rangeValue);
          }
        } else {
          returnFilters.push(
            Object.assign(Object.assign({}, currentFilter), { value: this.activeFilters[key] }),
          );
        }
      }
      return returnFilters;
    },
  },
  methods: {
    ...mapActions({
      changeFilters: 'productsFilters/changeFilters',
      resetFilters: 'productsFilters/resetFilters',
    }),
    remove(item, type) {
      if (item.filterType === 'FormCheckboxList') {
        const value = [].concat(this.activeFilters[item.filterKey]);
        const index = value.indexOf(item.value);
        value.splice(index, 1);
        this.changeFilters({ type: 'search', name: item.filterKey, value });
      } else if (item.type === 'FormRange') {
        if (type === 'from') {
          this.changeFilters({
            type: 'search',
            name: item.key,
            value: { ...this.activeFilters[item.key], from: Math.floor(item.min) },
          });
        } else {
          this.changeFilters({
            type: 'search',
            name: item.key,
            value: { ...this.activeFilters[item.key], to: Math.ceil(item.max) },
          });
        }
      } else {
        this.changeFilters({ type: 'search', name: item.key, value: '' });
      }
    },
    getRadioValue(item) {
      const returnValue = item.values.filter(x => x.value === item.value.toString());
      if (returnValue && returnValue[0])
        return item.values.filter(x => x.value === item.value.toString())[0].label;
      else return '';
    },
    clearFilters() {
      this.resetFilters({ type: 'search' });
    },
  },
};
</script>

<style lang="scss">
.searchFiltersValues {
  $root: &;
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;

  &__filter {
    padding-left: 5px;
    padding-right: 5px;
    margin-top: 15px;

    &--purple {
      #{$root}__filterInner {
        background-color: $cMain;
        color: $cWhite;
      }

      #{$root}__filterRemove {
        color: $cWhite;

        &:hover {
          background-color: $cAddNeutral;
          color: $cMain;
        }
      }
    }
  }

  &__filterWrapper {
    display: flex;
    flex-wrap: wrap;
  }

  &__filterInner {
    position: relative;
    padding: 0.8rem 3.5rem 0.8rem 1rem;
    background-color: rgba($cAddNeutral, 0.2);
    font-size: 1.1rem;
    line-height: 1.4rem;
    font-weight: 700;
    white-space: nowrap;
  }

  &__filterRemove {
    position: absolute;
    right: 0;
    top: 0;
    width: 2.5rem;
    height: 100%;
    color: $cAddDark02;
    font-size: 0.8rem;
    transition: background-color $tr, color $tr;

    &:hover {
      background-color: $cMain;
      color: $cWhite;
    }
  }
}
</style>
